import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
const URI = ApiEndpoint + 'administration/';

const EditFormatoQueja = ({ idFormatosQueja, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [formatoqueja, setFormatoQueja] = useState({
    formato: ''
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getFormatoQueja = async () => {
    setFormatoQueja(null);

    httpClient(
      'GET',
      URI + 'formatoqueja/' + idFormatosQueja,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setValue('formato', response.data.formato);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const onSubmit = data => {
    console.log(data);

    if (idFormatosQueja > 0) {
      httpClient(
        'put',
        URI + 'formatoqueja/' + idFormatosQueja,
        {
          formato: data.formato
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'formatoqueja',
        {
          formato: data.formato
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  useEffect(() => {
    if (idFormatosQueja > 0) getFormatoQueja();
  }, []);

  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Formato</Form.Label>
                <FormControl
                  {...register('formato', {
                    required: 'El Formato es requerido'
                  })}
                  type="text"
                  defaultValue={formatoqueja?.formato}
                  isInvalid={!!errors.formato}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.formato?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

EditFormatoQueja.propTypes = {
  idFormatosQueja: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};

export default EditFormatoQueja;
